module.exports = __webpack_public_path__ + "static/media/dec 2021.ce8a6a5e.svg";